import { useState } from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { ProductCard } from "./ProductCard";

import ProdOne from "../../../Assets/Images/prod_one.svg";
import ProdTwo from "../../../Assets/Images/prod_two.svg";

export function ProductCards() {
  const [bestCardTitle, setBestCardTitle] = useState("Expert Advice");
  const theme = useTheme();
  const isLaptopScreen = useMediaQuery(theme.breakpoints.up("md"));  // Detecting laptop screen size

  const products = [
    {
      id: 1,
      title: "Demat Account",
      price: "399",
      features: ["Account opening charges"],
      image: ProdTwo,
      position: "left",
    },
    {
      id: 2,
      title: "Expert Advice",
      price: "1,999",
      features: ["Tailored Advice from SEBI registered Experts"],
      image: ProdOne,
      position: "middle",
    },
    {
      id: 3,
      title: "Wealth Vaults",
      price: "2,999",
      features: ["Energectic and Traditional Vaults"],
      image: ProdTwo,
      position: "right",
    },
  ];

  return (
    <Grid
      container
      spacing={{ xs: 3, sm: 3, md: 0 }}  // more space between cards on md and up
      justifyContent="center"
      sx={{
        width: "100%",
        margin: "0 auto",
        maxWidth: { xs: "100%", sm: "700px", md: "1100px", lg: "1200px" },
        px: { xs: 0, sm: 2, md: 3 },
      }}
    >
      {products.map((product) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          key={product.id}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ProductCard
            {...product}
            isBest={isLaptopScreen && bestCardTitle === product.title}  // Apply isBest only on laptop screens
            onHover={() => setBestCardTitle(product.title)}
            onLeave={() => setBestCardTitle("Expert Advice")}
          />
        </Grid>
      ))}
    </Grid>
  );
}
